import type { PaginationState, Updater } from "@tanstack/react-table";
import DatagridV2 from "ui-kit/src/Datagrid/DatagridV2";
import { _ } from "i18n";
import type { GameRow } from "../../../../datagrid-configs/discoverGames";
import type { ColumnVisibility } from "../../../../datagrid-configs/types";
import { DISCOVER_GAMES_PAGE_SIZE_OPTIONS } from "../constants";
import type { buildSimpleColumns } from "../helpers/buildSimpleColumns";

type SimpleColumns = ReturnType<typeof buildSimpleColumns>;

interface DiscoverGamesTableGridProps {
	items: GameRow[];
	simpleColumns: SimpleColumns;
	pagination: PaginationState;
	setPagination: (updater: Updater<PaginationState>) => void;
	pageCount: number;
	isLoading: boolean;
	visibleColumns: ColumnVisibility;
	onColumnWidthsChange: (widths: Record<string, number>) => void;
}

export function DiscoverGamesTableGrid({
	items,
	simpleColumns,
	pagination,
	setPagination,
	pageCount,
	isLoading,
	visibleColumns,
	onColumnWidthsChange,
}: DiscoverGamesTableGridProps) {
	return (
		<div className="discoverGamesTableV3-table">
			<DatagridV2<GameRow>
				noResults={_("datatables.zero_records")}
				data={items}
				simpleColumns={simpleColumns}
				pagination={pagination}
				setPagination={setPagination}
				pageCount={pageCount}
				isLoading={isLoading}
				columnVisibility={visibleColumns}
				onColumnWidthsChange={onColumnWidthsChange}
				pageSizeOptions={[...DISCOVER_GAMES_PAGE_SIZE_OPTIONS]}
				autoSizeColumns
				stickyHeader
				showPageSizeSelector
			/>
		</div>
	);
}
